import { HtmlId } from '../enums/elementId';
import { debugInfo } from './debug';

/**
 * Can be used to mount patterns with debugInfo integrated
 */
export const mountComponent = <Pattern, Props>(
    wrapperId: HtmlId,
    create: (containerElement: HTMLElement, props: Props) => Pattern,
    props: Props
): Pattern | undefined => {
    const containerEl = document.getElementById(wrapperId);

    if (!containerEl) {
        debugInfo('Couldn\'t mount element with id: ', wrapperId);

        return undefined;
    }

    try {
        return create(containerEl, props);
    } catch (error) {
        /* eslint-disable-next-line no-console */
        console.error(`Error while mounting brix component (id: ${wrapperId}):`, error);

        return undefined;
    }
};
